import CheckBoxController from './CheckBoxController'

export default CheckBoxController
